<template>
  <div
    v-click-outside="onClickOutside"
    class="form-autocomplete"
  >
    <div class="form-autocomplete__input">
      <slot name="input">
        <form-input
          ref="input"
          v-model="search"
          placeholder="Search"
          @input="onChange"
          @focus="isOpen = true;"
          @blur="onBlur"
          @keyup="isOpen = true;"
          @keyup.esc="isOpen = false;"
          @keyup.enter="onEnter"
        >
          <template #icon>
            <img
              :src="require('@/assets/icons/icon-search.svg')"
              alt="Search"
            >
          </template>
        </form-input>
      </slot>
    </div>
    <div
      v-show="isOpen"
      class="form-autocomplete__dropdown"
    >
      <ul
        v-if="availableResults.length > 0"
        class="form-autocomplete__results-list"
      >
        <li
          v-for="item in availableResults"
          :key="item.id"
          class="form-autocomplete__results-item"
        >
          <a
            href="#"
            @click.stop.prevent="onSelect(item)"
          >
            {{ item.label }}
          </a>
        </li>
      </ul>
      <div
        v-else
        class="no-results"
      >
        No results
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';

export default {
  name: 'form-autocomplete',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      results: this.items,
      isOpen: false,
    };
  },
  computed: {
    availableResults() {
      return this.results.filter(result => !this.selected.map(({ id }) => id).includes(result.id));
    },
  },
  watch: {
    items(val) {
      this.results = this.items;
    },
  },
  methods: {
    onClickOutside() {
      this.isOpen = false;
    },
    onBlur() {},
    onChange() {
      this.isOpen = true;
      this.filterResults();
    },
    onEnter() {
      if (this.availableResults.length > 0) {
        this.onSelect(this.availableResults[0]);
        this.$refs.input.$refs.input.blur();
      }
    },
    filterResults() {
      if (this.search === '') {
        this.results = this.items;
      }
      this.results = this.availableResults.filter(item => {
        const str = typeof item === 'string' ? item : Object.values(item).join(' ');
        return str.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
    },
    onSelect(item) {
      this.$emit('add', item);
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-autocomplete {
  position: relative;
  &__dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    background: #27274f;
    border: solid #b4b4d3;
    border-width: 2px 0 0;
    color: #b4b4d3;
    max-height: 200px;
    overflow-y: auto;
    box-shadow: 0 5px 5px #27274f;
  }
  &__results-list {}
  &__results-item {
    a {
      color: currentColor;
      text-decoration: none;
      padding: 2px 10px;
      display: block;
      .no-touchevents &:hover {
        background: #32325a;
      }
      &:active {
        background: #32325a;
      }
    }
  }
}
.no-results {
  text-align: center;
  padding: 5px 10px;
}
</style>
